import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function useAddress(): string | undefined {
	const value = useLastEventValueByQuery<{ county?: string; city: string }>(
		queries.address
	) || { city: "" };
	if (value === undefined) {
		return undefined;
	}
	const { county, city } = value;
	return county ? `${county}, ${city}` : city;
}
